import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { NavigationService } from "../../../shared/services/navigation.service";
import { ThemeService } from '../../services/theme.service';
import { Subscription } from "rxjs";
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { GraphqlMenuService } from 'app/service/graphql-menu.service';
import { Menu } from 'app/model/menu';
import { HelperService } from 'app/shared/services/helper/helper.service';
import { FichaUsuario } from 'app/model/usuario';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-sidebar-side',
  templateUrl: './sidebar-side.component.html'
})
export class SidebarSideComponent implements OnInit, OnDestroy, AfterViewInit {
  menuItems: any[];
  hasIconTypeMenuItem: boolean;
  iconTypeMenuTitle: string;
  menuItemsSub: Subscription;
  menu: Menu[];
  user: any;
  fichaUsuario: FichaUsuario = new FichaUsuario();

  constructor(private _navService: NavigationService,
              public _themeService: ThemeService,
              private _adalSvc: MsAdalAngular6Service,
              private _graphqlMenuService: GraphqlMenuService,
              public _helperService: HelperService,
              private _appLoaderService: AppLoaderService,
              private _router: Router) { 
    this.fichaUsuario = this._helperService.getItemSessionStorage("fichaUsuario");
  }

  ngOnInit() {
    this.user = this._adalSvc.userInfo;
    this.iconTypeMenuTitle = this._navService.iconTypeMenuTitle;
    setTimeout(() => {         
      this.obtenerMenu(); 
    }, 1500);
  }

  ngAfterViewInit() {}

  ngOnDestroy() {
    if (this.menuItemsSub) {
      this.menuItemsSub.unsubscribe()
    }
  }

  procesarMenu(): void {
    var listaFiltrada = this._navService.cargarMenuLateral(this.menu);
    this.menuItems = listaFiltrada;
    this.hasIconTypeMenuItem = !!this.menuItems.filter(item => item.type === 'icon').length;
  }

  obtenerMenu(): void {
    this._graphqlMenuService.getMenu(this.fichaUsuario.codigoUsuario).subscribe(
      res => { 
        if(this._helperService.isStatusOk(res)) {
          this.menu = res.menu;
          this.procesarMenu();
        } else {
          this._router.navigate(['/acceso-restringido']);          
        }        
      }, 
      err => this._helperService.observableError(err)
    )
  }
}
